<div class="field mb-4">
  <!-- Start::title -->
  <span class="text-900 text-2xl block font-semibold mb-5"
    >¿Dónde y desde cuándo quieres retirar tu pedido?</span
  >
  <!-- End::title -->

  <!-- Start::dirección seleccionada -->
  <div
    class="flex p-4 mt-3 lg:mt-0 mb-4 border-round border-1 w-full flex align-items-center justify-content-between min:h-6rem"
    [ngClass]="
      isLoadingStores()
        ? 'surface-border'
        : 'border-primary bg-blue-50 cursor-pointer'
    "
    (click)="sidebar.show()"
  >
    @if(isLoadingStores()){
    <div class="flex flex-column gap-2">
      <p-skeleton width="14rem" />
      <p-skeleton width="24rem" />
    </div>
    <p-skeleton width="2rem" styleClass="ml-auto" />

    } @else {
    <div class="flex flex-column gap-1">
      <div class="font-semibold">{{ selectedStore()?.name }}</div>
      <span class="text-sm uppercase">{{ selectedStore()?.address }}</span>
    </div>
    <i class="fa-sharp fa-solid fa-angle-right text-xl ml-auto"></i>
    }
  </div>
  <!-- End::dirección seleccionada -->

  <!-- Start:: -->
  <app-store-list-sidebar
    #sidebar
    [stores]="stores()"
    [selectedStoreCode]="selectedStore()?.code || null"
    (onSubmit)="onSelectStore($event)"
  />
  <!-- End::dirección -->

  @if(hasShippingGroups){
  <!-- Start::información -->
  <div
    class="p-4 surface-100 flex align-items-center justify-content-between mb-4"
  >
    <span class="mr-3 md:mr-5 text-sm"
      >Te informaremos por correo electrónico cuando esté listo para ser
      retirado.</span
    >
    <i class="fa-sharp-duotone fa-solid fa-circle-info text-4xl"></i>
  </div>
  <!-- End::información -->
  }
</div>
